import { Box, Container } from '@mui/material';
import { useParams } from 'react-router-dom';
import PageHeader from 'components/common/PageHeader/PageHeader';
import CategoryTree from 'components/Category/CategoryTree/CategoryTree';
import StoreProductCarousel from 'components/Store/StoreProductCarousel/StoreProductCarousel';
import { useGetStoreById } from 'hooks/useStore';
import useGlobalStyles from 'styles/globalStyles';

// One store's products laid over the taxonomy, the way the raw products
// categories page lays out raw products.
export default function StoreProductsPage() {
  const globalStyles = useGlobalStyles();
  const storeId = String(useParams().storeId);

  const { data: store } = useGetStoreById(storeId, {
    select: (res: any) => res.data,
  });

  return (
    <Container
      maxWidth={'xl'}
      className={globalStyles.container}
    >
      <Box pt={2}>
        <PageHeader
          title={(store as any)?.info?.name ? `${(store as any).info.name} Products` : 'Store Products'}
          buttons={[]}
        />
      </Box>

      <Box mt={3}>
        <CategoryTree
          basePath={`/stores/all-stores/${storeId}/products`}
          renderCarousel={() => <StoreProductCarousel storeId={storeId} />}
          showAdd={false}
        />
      </Box>
    </Container>
  )
}
